var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){return _vm.downloadAsync(_vm.report)}}},[_vm._t("default")],2),_c('loader-dialog',{attrs:{"show":_vm.loading,"msg":"Загрузка"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }